var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"like-btn",attrs:{"title":_vm.likeTitle}},[_c('i',{class:_vm.cls,on:{"click":function($event){$event.preventDefault();return _vm.addToLikes($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }